import { useState, useEffect } from 'react';

// Localização do visitante detectada pelo IP (cidade + estado). Uma única
// consulta por sessão, compartilhada entre todos os componentes que usarem o hook.
const FALLBACK = { city: 'sua cidade', region: '' };
let locationPromise = null;

async function fetchLocationFromIp() {
  // 1) ipapi.co
  try {
    const res = await fetch('https://ipapi.co/json/');
    if (res.ok) {
      const data = await res.json();
      if (data?.city) {
        return {
          city: String(data.city).trim(),
          region: String(data.region_code || data.region || '').trim(),
        };
      }
    }
  } catch (_) {
    // tenta o próximo provedor
  }

  // 2) wtfismyip.com ("Cidade, Estado, País")
  try {
    const res = await fetch('https://wtfismyip.com/json');
    if (res.ok) {
      const data = await res.json();
      const parts = String(data?.YourFuckingLocation || '').split(',').map((p) => p.trim());
      if (parts[0]) return { city: parts[0], region: parts[1] || '' };
    }
  } catch (_) {
    // sem provedor disponível
  }

  return FALLBACK;
}

export function getLocationFromIp() {
  if (!locationPromise) {
    locationPromise = fetchLocationFromIp().catch(() => FALLBACK);
  }
  return locationPromise;
}

export function useGeolocation() {
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    getLocationFromIp().then((result) => {
      if (!active) return;
      setLocation(result);
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, []);

  return { city: location?.city ?? null, region: location?.region ?? '', loading };
}
